import { IonCard, IonCardContent, IonCardTitle, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonItem, IonLabel } from '@ionic/react';
import { add, documentTextOutline } from 'ionicons/icons';
import { Link, useParams } from 'react-router-dom';
import backend, { get_doc_thumb_url } from '@/controllers/backend'
import Image from '@/components/Image'
import slug from '@/controllers/slug';
import { useEffect, useState } from 'react';

const DocumentList: React.FC = ({ repo_id, title, docs, query }) => {
    if (docs.length == 0 && repo_id != "docs") {
        return;
    }

    if (query.has("q") && query.get("q").trim().length > 0) {
        return (<>
    <IonItem color="light">
        <IonLabel>{title}</IonLabel>
    </IonItem>
<IonCard className="bg-white dark:bg-gray-800 shadow-lg m-0 py-2 px-2 rounded-none">
  {docs.length > 0 ? (
    <div className="grid grid-cols-1 gap-0">
      {docs.map((doc, index) => (
        <Link
        to={`/docs/${doc.id}/${slug(doc.name)}`}
        key={index}
        className="block pb-6"
        >
        <div className="bg-white dark:bg-gray-700 shadow-md rounded-lg overflow-hidden h-48 transition-transform duration-300 flex items-stretch">
            
            {/* Left: Fixed-height Image */}
            <div className="w-1/4 h-full">
            <Image
                src={get_doc_thumb_url(doc.id)}
                alt={doc.name}
                className="w-full h-full object-cover"
            />
            </div>

            {/* Right: Scrollable Text Area */}
            <div className="w-3/4 p-4 overflow-y-none relative">
            <h3 className="font-bold text-gray-800 dark:text-white break-all mb-2">
                {doc.name.slice(0, 64)}
            </h3>
            <p className="text-gray-600 dark:text-gray-300">
                <span dangerouslySetInnerHTML={{
                            __html: doc.headline,
                        }}>
                </span>
            </p>
            <p className="text-gray-500 dark:text-gray-400">{doc.rank}</p>
            <div className='absolute top-1 right-2'>{doc.rank}</div>
            </div>
        </div>
        </Link>
      ))}
    </div>
    ) : (
        <div className="p-8 text-center m-auto">
            <IonIcon icon={documentTextOutline} className="text-4xl text-gray-400 dark:text-gray-500 mx-auto mb-4" />
            <p className="text-gray-500 dark:text-gray-400">
                No documents uploaded yet.
            </p>
            <p className="text-gray-500 dark:text-gray-400">
                Click the <IonIcon className='align-middle mb-1' icon={add} /> button on top right to add your documents
            </p>
            <p className="text-gray-500 dark:text-gray-400 pt-1">
                You can also search some publicly available documents below.
            </p>
        </div>
    )}
    </IonCard>
    </>)
    } else {
        return (<>
    <IonItem color="light">
        <IonLabel>{title}</IonLabel>
    </IonItem>
    <IonCard className="bg-white dark:bg-gray-800 shadow-lg m-0 py-2 px-2 rounded-none">
    {docs.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-0 ">
            {docs.map((doc, index) => (
                <Link to={`/docs/${doc.id}/${slug(doc.name)}`} key={index} className="block pb-6">
                    <IonCard className="bg-white dark:bg-gray-700 shadow-md rounded-lg overflow-hidden h-full transition-transform duration-300 hover:scale-105 hover:shadow-lg">
                        <div className="relative pb-[140%]">
                            <Image src={get_doc_thumb_url(doc.id)} alt={doc.name} />
                        </div>
                        <IonCardContent className="p-0 mx-2 mt-3">
                            <h3 className="font-bold text-gray-800 dark:text-white text-center break-all">{doc.name.slice(0,32)}</h3>
                            {/* <p>{doc.orig_last_modified}</p>
                            <p>{doc.inserted_at}</p>
                            <p>{doc.hash}</p>
                            <p>{doc.filename}</p> */}
                        </IonCardContent>
                    </IonCard>
                </Link>
            ))}
        </div>
    ) : (
        <div className="p-8 text-center m-auto">
            <IonIcon icon={documentTextOutline} className="text-4xl text-gray-400 dark:text-gray-500 mx-auto mb-4" />
            <p className="text-gray-500 dark:text-gray-400">
                No documents uploaded yet.
            </p>
            <p className="text-gray-500 dark:text-gray-400">
                Click the <IonIcon className='align-middle mb-1' icon={add} /> button on top right to add your documents
            </p>
            <p className="text-gray-500 dark:text-gray-400 pt-1">
                You can also search some publicly available documents below.
            </p>
        </div>
    )}
    </IonCard>
    </>)
    }
};

export default DocumentList;
